// Fonte: UManutContas.pas — bancoEmp() linha ~11769 e AlteraBancoEmp() linha ~13080
// Lista famílias do GE com checkboxes (pré-marcados). Usuário pode desmarcar.
// Atualiza dados bancários só nas famílias selecionadas (paridade com grid galtemp ST='S').
import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner, Form, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  atualizarBancoEmpreendimento,
  listarFamiliasBancoEmpreendimento,
} from '~/Services/Service';

var ModalBancoEmpreendimento = function(_ref) {
  var show = _ref.show;
  var ge = _ref.ge;
  var codigo = _ref.codigo;
  var onHide = _ref.onHide;
  var onConcluido = _ref.onConcluido;

  var [familias, setFamilias] = useState([]);
  var [selecionadas, setSelecionadas] = useState({});
  var [carregando, setCarregando] = useState(false);
  var [salvando, setSalvando] = useState(false);

  useEffect(function() {
    if (!show || !ge) return;
    setCarregando(true);
    listarFamiliasBancoEmpreendimento(ge)
      .then(function(resp) {
        var lista = resp.data || [];
        setFamilias(lista);
        var pre = {};
        lista.forEach(function(f) { pre[f.codigoFamilia] = true; });
        setSelecionadas(pre);
      })
      .catch(function() {
        toast.error('Erro ao listar empreendimentos do GE');
        setFamilias([]);
      })
      .finally(function() { setCarregando(false); });
  }, [show, ge]);

  var toggle = function(codigoFamilia) {
    setSelecionadas(function(s) {
      var novo = Object.assign({}, s);
      novo[codigoFamilia] = !s[codigoFamilia];
      return novo;
    });
  };

  var marcarTodas = function(valor) {
    var novo = {};
    familias.forEach(function(f) { novo[f.codigoFamilia] = valor; });
    setSelecionadas(novo);
  };

  var selecionadasIds = familias
    .map(function(f) { return f.codigoFamilia; })
    .filter(function(id) { return selecionadas[id]; });

  var handleConfirmar = function() {
    if (selecionadasIds.length === 0) {
      toast.warn('Selecione ao menos um empreendimento');
      return;
    }
    setSalvando(true);
    atualizarBancoEmpreendimento({
      codigo_grupo_empresa: ge,
      codigo_conta: codigo,
      familias: selecionadasIds,
    })
      .then(function() {
        toast.success('Dados bancários atualizados nos empreendimentos!');
        if (onConcluido) onConcluido();
        onHide();
      })
      .catch(function() {
        toast.error('Erro ao atualizar dados bancários nos empreendimentos');
      })
      .finally(function() { setSalvando(false); });
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton className="contas-modal-header">
        <Modal.Title>Atualizar Banco nos Empreendimentos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          Este banco possui <strong>Liquidez Imediata</strong>.
          Selecione os empreendimentos que receberão os dados bancários desta conta:
        </p>
        {carregando ? (
          <div className="text-center py-3"><Spinner animation="border" size="sm" /> Carregando...</div>
        ) : familias.length === 0 ? (
          <p className="text-muted">Nenhum empreendimento encontrado para este GE.</p>
        ) : (
          <>
            <div className="mb-2">
              <Button variant="link" size="sm" className="p-0 mr-3" onClick={function() { marcarTodas(true); }}>
                Marcar todos
              </Button>
              <Button variant="link" size="sm" className="p-0" onClick={function() { marcarTodas(false); }}>
                Desmarcar todos
              </Button>
            </div>
            <Table striped size="sm" className="mb-0">
              <thead>
                <tr>
                  <th style={{ width: 40 }}></th>
                  <th>Empreendimento</th>
                  <th>Banco</th>
                  <th>Agência</th>
                  <th>Conta</th>
                  <th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                {familias.map(function(f) {
                  return (
                    <tr key={f.codigoFamilia}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={!!selecionadas[f.codigoFamilia]}
                          onChange={function() { toggle(f.codigoFamilia); }}
                        />
                      </td>
                      <td>{f.nomeDaFamilia}</td>
                      <td>{f.banco || '-'}</td>
                      <td>{f.agencia || '-'}</td>
                      <td>{f.conta || '-'}</td>
                      <td>{f.tipoConta != null ? f.tipoConta : '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={salvando}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirmar}
          disabled={salvando || carregando || selecionadasIds.length === 0}
        >
          {salvando ? <Spinner animation="border" size="sm" /> : 'Atualizar selecionados'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalBancoEmpreendimento;
